<template>
  <div>
    <vue-progress-bar></vue-progress-bar>
    <router-view />
    <flash-message />
    <div class="modals">
      <TermsModal />
      <VerificationSuccessModal />
    </div>
  </div>
</template>

<script>
import TermsModal from './components/Modals/GDPR/index.vue'
import VerificationSuccessModal from '@/components/Modals/VerificationSuccess'

export default {
  components: {
    VerificationSuccessModal,
    TermsModal
  },
  data() {
    return {
      mounted: false
    }
  },
  map: state => ({
    userInfo: state.user.userInfo,
    locale: state.app.locale
  }),
  watch: {
    $route(route) {
      const isStaticPagesRoute = route.matched.some(r => r.name === 'StaticPages')
      if (
        this.$state.userInfo &&
        this.$state.userInfo.role !== 'guest' &&
        !this.$state.userInfo.acceptedTerms &&
        !isStaticPagesRoute
      ) {
        this.$modal.show('terms-modal', { newUser: false })
      }
    }
  },
  created() {
    this.$router.beforeEach((to, from, next) => {
      this.$Progress.start()
      next()
    })
    this.$router.afterEach(() => {
      this.$Progress.finish()
    })
    const { locale } = this.$state
    this.$i18n.locale = locale
    this.$moment.locale(locale === 'no' ? 'nb' : locale)
  },
  mounted() {
    this.$Progress.finish()
    const isStaticPagesRoute = this.$route.matched.some(r => r.name === 'StaticPages')
    if (
      this.$state.userInfo &&
      this.$state.userInfo.role !== 'guest' &&
      !this.$state.userInfo.acceptedTerms &&
      !isStaticPagesRoute
    ) {
      this.$modal.show('terms-modal', { newUser: false })
    }
    this.initStripe()
    this.initAnalytics(this.$state.userInfo)
  },
  methods: {
    initStripe() {
      const stripe = document.createElement('script')
      stripe.setAttribute('src', 'https://js.stripe.com/v3')
      document.head.appendChild(stripe)
    },
    initAnalytics() {
      this.$analytics.initAnalytics(this.$state.userInfo)
    }
  }
}
</script>

<style>
@import './assets/css/cookies.css';
html {
  font-family: 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif;
  font-size: 16px;
  word-spacing: 1px;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
}

*,
*:before,
*:after {
  box-sizing: border-box;
  margin: 0;
}

.button--green {
  display: inline-block;
  border-radius: 4px;
  border: 1px solid #3b8070;
  color: #3b8070;
  text-decoration: none;
  padding: 10px 30px;
}

.button--green:hover {
  color: #fff;
  background-color: #3b8070;
}

.cc-revoke {
  display: none !important;
}

img {
  visibility: hidden;
}

img[src] {
  visibility: visible;
}

.button--grey {
  display: inline-block;
  border-radius: 4px;
  border: 1px solid #35495e;
  color: #35495e;
  text-decoration: none;
  padding: 10px 30px;
  margin-left: 15px;
}

.button--grey:hover {
  color: #fff;
  background-color: #35495e;
}
.intercom-app .intercom-launcher-frame {
  z-index: 100 !important;
}
@media (max-width: 560px) {
  #coi-cookie {
    bottom: 0 !important;
  }
}
</style>
